import { faqData } from '@/mocks/home';

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12 max-w-[600px] mx-auto">
          关于国产91视频、视频APP下载与移动端播放的常见疑问解答
        </p>

        <div className="max-w-[900px] mx-auto space-y-3">
          {faqData.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 transition-colors hover:border-primary-200/60"
            >
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2">
                {item.question}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}